import React from 'react';

const useDelayedLoadingState = (isLoading, delay = 300) => {
  const [delayedLoadingState, setDelayedLoadingState] = React.useState(false);

  React.useEffect(() => {
    let loadingTimeout;

    if (isLoading) {
      loadingTimeout = setTimeout(() => {
        setDelayedLoadingState(true);
      }, delay);
    } else {
      clearTimeout(loadingTimeout);
      setDelayedLoadingState(false);
    }

    return () => {
      if (loadingTimeout) {
        clearTimeout(loadingTimeout);
      }
    };
  }, [isLoading, delay]);

  return delayedLoadingState;
};

export default useDelayedLoadingState;
